document.addEventListener('DOMContentLoaded', function () {
    const coursesGrid = document.getElementById('coursesGrid');
    const sentinel = document.getElementById('coursesSentinel');
    const moreLoader = document.getElementById('coursesMoreLoader');
    const filterList = document.getElementById('filterList');
    const filterSearch = document.getElementById('filterSearch');

    if (!coursesGrid) return;

    const coursesPerPage = 9;
    const topLoader = document.getElementById('coursesLoader');

    let currentPage = 0;      // highest page loaded so far (0 = none yet)
    let totalPages = 1;
    let isLoading = false;
    let reachedEnd = false;
    let requestToken = 0;     // guards against stale responses when filters change

    // Lazy-reveal: each card link starts faded + shifted down (.reveal) and
    // fades/rises into place (.is-revealed) the moment it scrolls into view, so
    // courses visibly load in while scrolling. Added by JS only, so the cards
    // stay visible if scripting/IntersectionObserver is unavailable.
    const revealObserver = ('IntersectionObserver' in window)
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-revealed');
                    revealObserver.unobserve(entry.target);
                }
            });
        }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.1 })
        : null;

    function getFilters() {
        const activeBtn = filterList ? filterList.querySelector('.dashboard__filter-btn--active') : null;
        return {
            category: activeBtn ? activeBtn.getAttribute('data-filter') : 'all',
            search: filterSearch ? filterSearch.value : ''
        };
    }

    function clearCards() {
        Array.from(coursesGrid.children).forEach(function (child) {
            if (child !== topLoader) child.remove();
        });
    }

    function cardMarkup(course) {
        return `
            <a href="${course.link || ''}" class="reveal">
                <div class="dashboard__course-card">
                    <div class="dashboard__course-image">
                        <img src="${course.image || ''}" alt="${course.title || ''}" loading="lazy" decoding="async">
                    </div>
                    <div class="dashboard__course-info">
                        ${course.topTitle ? `<span class="dashboard__course-top-title">${course.topTitle}</span>` : ''}
                        <h3 class="dashboard__course-title">${course.title || ''}</h3>
                        ${course.label ? `<span class="dashboard__course-label">${course.label}</span>` : ''}
                    </div>
                </div>
            </a>
        `;
    }

    function appendCourses(courses) {
        courses.forEach(function (course, i) {
            coursesGrid.insertAdjacentHTML('beforeend', cardMarkup(course));
            const link = coursesGrid.lastElementChild;
            if (!link) return;
            // Slight per-column stagger so a row ripples in instead of popping together.
            link.style.transitionDelay = (i % 3) * 60 + 'ms';
            if (revealObserver) revealObserver.observe(link);
            else link.classList.add('is-revealed');
        });
    }

    function showTopLoader(show) { if (topLoader) topLoader.style.display = show ? 'flex' : 'none'; }
    function showMoreLoader(show) { if (moreLoader) moreLoader.style.display = show ? 'flex' : 'none'; }

    function updateSentinel() {
        if (sentinel) sentinel.style.display = reachedEnd ? 'none' : '';
    }

    // Load a single page. reset=true (new filter/search/initial) clears the grid
    // and restarts; reset=false appends the next page for infinite scroll.
    function loadPage(page, reset) {
        if (isLoading) return;
        if (!reset && (reachedEnd || page > totalPages)) return;

        isLoading = true;
        const token = ++requestToken;
        const filters = getFilters();

        if (reset) {
            reachedEnd = false;
            totalPages = 1;
            clearCards();
            showTopLoader(true);
        } else {
            showMoreLoader(true);
        }

        const url = '/api/program/courses?category=' + encodeURIComponent(filters.category)
            + '&search=' + encodeURIComponent(filters.search)
            + '&page=' + page + '&limit=' + coursesPerPage;

        fetch(url)
            .then(function (response) { return response.json(); })
            .then(function (result) {
                if (token !== requestToken) return; // a newer request superseded this one

                if (result && result.success && Array.isArray(result.data)) {
                    if (reset && result.data.length === 0) {
                        coursesGrid.insertAdjacentHTML('beforeend',
                            '<div class="dashboard__no-results">No courses found matching your criteria.</div>');
                    } else {
                        appendCourses(result.data);
                    }
                    const pagination = result.pagination || {};
                    currentPage = pagination.page || page;
                    totalPages = pagination.totalPages || 1;
                    reachedEnd = currentPage >= totalPages;

                    // Keep filling while the sentinel stays in view (e.g. short pages
                    // or a tall viewport) so the screen is never left half-empty.
                    if (!reachedEnd && result.data.length > 0) {
                        requestAnimationFrame(maybeLoadMore);
                    }
                }
            })
            .catch(function (error) {
                if (token !== requestToken) return;
                console.error('Error fetching courses:', error);
            })
            .then(function () { // runs as a finally for the current request
                if (token !== requestToken) return;
                isLoading = false;
                showTopLoader(false);
                showMoreLoader(false);
                updateSentinel();
            });
    }

    function sentinelInView() {
        if (!sentinel) return false;
        const viewportH = window.innerHeight || document.documentElement.clientHeight;
        return sentinel.getBoundingClientRect().top <= viewportH + 400;
    }

    function maybeLoadMore() {
        if (isLoading || reachedEnd || currentPage < 1) return;
        if (sentinelInView()) loadPage(currentPage + 1, false);
    }

    // Public hook used by filters.js (category buttons + search). page <= 1 resets.
    window.fetchCourses = function (page) {
        page = page || 1;
        if (page <= 1) {
            currentPage = 0;
            loadPage(1, true);
        } else {
            loadPage(page, false);
        }
    };

    // Infinite scroll: observe the bottom sentinel; fall back to scroll/resize.
    if (sentinel && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) maybeLoadMore();
            });
        }, { root: null, rootMargin: '400px 0px' });
        observer.observe(sentinel);
    } else {
        window.addEventListener('scroll', maybeLoadMore, { passive: true });
        window.addEventListener('resize', maybeLoadMore, { passive: true });
    }

    // Initial load.
    window.fetchCourses(1);
});
